import React, { useEffect, useState } from "react";
import classnames from "classnames";
import * as url from "../api/urls";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Collapse,
  Form,
} from "reactstrap";

//utils
// interfaaces
import { CreateChannelPostData, getChatUserDetails2s } from "../redux/actions";
import Loader from "./Loader";
import { APIClient } from "api/apiCore";
import { UserTypes } from "api";
import { createSelector } from "reselect";
import { getCurrentUserAction } from "../redux/profile2/p2_reducer";
import { useRedux } from "hooks";

interface UserProfileModalProps {
  isOpen: boolean;
  userId: number;
  onClose: () => void;
  //onCreateChannel: (params: CreateChannelPostData) => void;
}
const UserProfileModal = ({
  isOpen,
  userId,
  onClose,
  //onCreateChannel,
}: UserProfileModalProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state) => state.Profile2,
    (state) => state.Chats,
    (state, chats) => ({
      curUserId: state.userId,
      curUserType: state.userType,
      selectedChat: chats.selectedChat,
    })
  );
  const { curUserId, selectedChat } = useAppSelector(storeData);

  const onSubmit = () => {
    try {
      if (!dbFirstName) {
        alert('กรุณาระบุชื่อ');
        return;
      }
      setIsLoading(true);

      const api = new APIClient();
      const parm = {
        userId: dbUserId,
        firstName: dbFirstName,
        lastName: dbLastName,
        nickName: dbNickName,
        displayName: manualDisplayName ? dbDisplayName2 : ""
      };
      api.fnPostForm(url.UPDATE_USER_FROM_EDIT, parm)
        .then((rs) => {
          if (rs.success) {
            // alert('บันทึกข้อมูลสำเร็จ');
            if (dbUserId == curUserId) {
              dispatch(getCurrentUserAction());
            }
            dispatch(getChatUserDetails2s(selectedChat, false, true, false));
            onClose();
          } else {
            alert(rs.message);
          }
          setIsLoading(false);
        })
        .catch((e) => {
          console.error(e);
          alert((e as any).message);
          setIsLoading(false);
        });
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  };

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [dbUserId, setDbUserId] = useState<number>(-1);
  const [dbFirstName, setDbFirstname] = useState<string>("");
  const [dbLastName, setDbLastName] = useState<string>("");
  const [dbNickName, setDbNickName] = useState<string>("");
  const [dbDisplayName, setDbDisplayname] = useState<string>("");
  const [dbDisplayName2, setDbDisplayname2] = useState<string>("");
  const [dbDisplayName2Org, setDbDisplayName2Org] = useState<string>("");
  const [dbAuthMobileNo, setDbAuthMobileNo] = useState<string>("");
  const dbFullName = (dbFirstName.trim() + " " + dbLastName.trim()).trim();
  const [manualDisplayName, setManualDisplayName] = useState<boolean>(false);
  const [dbUserType, setDbUserType] = useState<UserTypes>(UserTypes.Customer);
  //const [canEdit, setCanEdit] = useState<boolean>(false);
  //const canEdit = curUserId == dbUserId || dbUserType == UserTypes.Customer;
  const canEdit = curUserId == dbUserId || dbUserType == UserTypes.Customer || dbUserType == UserTypes.Supplier;

  useEffect(() => {
    if (!manualDisplayName) {
      const found = [dbFirstName, dbLastName].find(t => dbNickName && t.toLocaleLowerCase() == dbNickName.toLocaleLowerCase())
      // const bIncludeNickName = dbNickName && dbFirstName != dbNickName && dbLastName != dbNickName;
      setDbDisplayname2(dbFullName + (!found ? ` (${dbNickName})` : ""));
    }

  }, [, dbFullName, dbNickName, manualDisplayName]);

  const userTypeText = dbUserType == UserTypes.Employee ? "พนักงาน" : "ลูกค้า";

  useEffect(() => {
    try {
      if (isOpen && userId > 0) {
        setIsLoading(true);
        const api = new APIClient();

        api.fnPostForm(url.LOAD_USER_FOR_EDIT, { userId: userId })
          .then((rs: any) => {
            if (rs.success) {
              setDbUserId(rs.data.userId);
              setDbFirstname(rs.data.firstName);
              setDbLastName(rs.data.lastName);
              setDbNickName(rs.data.nickName);
              setDbDisplayname(rs.data.displayName);
              setDbDisplayname2(rs.data.displayName2);
              setDbDisplayName2Org(rs.data.displayName2);
              setDbAuthMobileNo(rs.data.authMobileNo);
              setDbUserType(rs.data.userType);
            } else {
              alert(rs.message);
            }
            setIsLoading(false);
          })
          .catch((e: any) => {
            console.error(e);
            alert((e as any).message);
            setIsLoading(false);
          })

        // console.log('reload user info ' + userId);
      }
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }, [, userId, isOpen]);

  // useEffect(()=>{

  // },[,dbFirstName, dbLastName]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      tabIndex={-1}
      centered
      scrollable
      color="white"
      id="addgroup-exampleModal"
      role="dialog">
      <ModalHeader toggle={onClose} className="bg-primary">
        <div className="modal-title modal-title-custom text-white bg-primary font-size-16">
          ข้อมูลของ "{dbDisplayName2Org ? `${userTypeText}: ${dbDisplayName2Org}` : "loading..."}"
        </div>
      </ModalHeader>

      <ModalBody className="p-4">
        <div>
          {isLoading && (<Loader></Loader>)}
          <div className="row mb-2">
            <div className="col-12 col-sm-6">
              ชื่อ
              <input type="text" className="form-control" value={dbFirstName} readOnly={!canEdit} onChange={(e) => setDbFirstname(e.target.value)}></input>
            </div>
            <div className="col-12 col-sm-6">
              นามสกุล
              <input type="text" className="form-control" value={dbLastName} readOnly={!canEdit} onChange={(e) => setDbLastName(e.target.value)}></input>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-12 col-sm-6">
              ชื่อเล่น
              <input type="text" className="form-control" value={dbNickName} readOnly={!canEdit} onChange={(e) => setDbNickName(e.target.value)}></input>
            </div>
            <div className="col-12 col-sm-6">
              โทร
              <input type="text" className="form-control" value={dbAuthMobileNo} readOnly={true}></input>
            </div>
          </div>
          <div className="row">
            <div className="col">
              ชื่อเต็ม
              <input type="text" className="form-control" value={dbFullName} readOnly={true}></input>
            </div>
          </div>
          <div className="row">
            <div className="col">
              ชื่อที่แสดง
              {canEdit && (
                <>
                  &nbsp;<input type="checkbox" id="chkManualName" onChange={(e) => setManualDisplayName(e.target.checked)}></input><label htmlFor="chkManualName">กำหนดเอง</label>
                </>
              )}
              <input type="text" className="form-control" value={dbDisplayName2} onChange={(e) => setDbDisplayname2(e.target.value)} readOnly={!manualDisplayName} ></input>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="link" type="button" onClick={onClose}>
          ปิด
        </Button>
        {canEdit && (
          <Button
            type="button"
            color="primary"
            onClick={onSubmit}
          // disabled={!valid}
          >
            ตกลง
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default UserProfileModal;
